import React, { FC } from 'react'

import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui'

import { MasterCampaignPlan } from 'api/interfaces/MasterCampaignPlan'
import { MasterCampaignPlanCustomSection } from 'api/interfaces/MasterCampaignPlan'

import CustomizableSection from './CustomizableSection'

export interface AudienceAndGeoTargetingProps {
  masterCampaignPlan: MasterCampaignPlan
  audienceSection: MasterCampaignPlanCustomSection | null | undefined
  geoSection: MasterCampaignPlanCustomSection | null | undefined
  onEditAudience: () => void
  onDeleteAudience: () => void
  onEditGeo: () => void
  onDeleteGeo: () => void
  showActions?: boolean
}

const AudienceAndGeoTargeting: FC<AudienceAndGeoTargetingProps> = ({ masterCampaignPlan, audienceSection, geoSection, onEditAudience, onDeleteAudience, onEditGeo, onDeleteGeo, showActions = true }) => {
  const audienceHidden = audienceSection?.hideAll === true
  const geoHidden = geoSection?.hideAll === true

  const bothVisible = !audienceHidden && !geoHidden

  return (
    <EuiFlexGroup direction='row' gutterSize='xl' alignItems='flexStart' wrap>
      {!audienceHidden && (
        <EuiFlexItem style={{ flexBasis: bothVisible ? '500px' : '100%', minHeight: '0' }}>
          <CustomizableSection section={audienceSection} defaultTitle='Audience Strategy' defaultContent={masterCampaignPlan.audienceSummary} defaultShowTitle={true} separator='horizontalRule' onEdit={onEditAudience} onDelete={onDeleteAudience} showActions={showActions} />
        </EuiFlexItem>
      )}
      {!geoHidden && (
        <EuiFlexItem style={{ flexBasis: bothVisible ? '500px' : '100%', minHeight: '0' }}>
          <CustomizableSection section={geoSection} defaultTitle='Geographic Targeting' defaultContent={masterCampaignPlan.geoSummary} defaultShowTitle={true} separator='horizontalRule' onEdit={onEditGeo} onDelete={onDeleteGeo} showActions={showActions} />
        </EuiFlexItem>
      )}
    </EuiFlexGroup>
  )
}

export default AudienceAndGeoTargeting
